import InputMask from "react-input-mask";
/* eslint-disable quote-props */
import { styled } from "@mui/material";

const GvInputMask = styled(InputMask)(({ theme }) => ({
  font: "inherit",
  letterSpacing: "inherit",
  color: "currentColor",
  boxSizing: "border-box",
  display: "block",
  width: "100%",
  backgroundColor: "#fff",
  position: "relative",
  fontSize: "0.8125rem", // 13px converted to rem
  padding: "0.6875rem 0.75rem", // 11px 12px converted to rem
  borderRadius: "0.5rem", // 8px converted to rem
  marginTop: "0.3125rem", // 5px converted to rem
  border: "0.0625rem solid #E8DFD7", // 1px converted to rem
  "&:focus": {
    outline: "none",
    border: `0.0625rem solid ${theme.palette.primary.main}`, // 1px converted to rem
  },
  "&.error": {
    borderWidth: "0.0625rem", // 1px converted to rem
    border: `0.0625rem solid ${theme.palette.error.main}`, // 1px converted to rem
    backgroundColor: theme.palette.error.light,
  },
  "&:disabled": {
    backgroundColor: "#fff !important",
    color: "#A0A0A0",
  },
}));

export default GvInputMask;
